
import store from 'store2'

export default async function outOfBandComplete (state, appOptions) {
  const AdvisoryMessage = (await import(/* webpackChunkName: 'advisory-message' */ '@polleverywhere/toolkit/components/advisory_message')).default

  const view = new AdvisoryMessage({
    iconName: 'refresh',
    subject: 'Please wait',
    message: 'Logging you in...',
    spinIcon: true
  })

  Backbone.ajax({
    method: 'PUT',
    url: `/auth/out_of_band_authentication_codes/${store.page.get('auth_code')}`,
    contentType: 'application/json'
  }).then((a, b, c) => {
    window.close()
  }).catch((e) => {
    console.error('OOB Auth failed', e)
  })

  return view
}
